<h2 mat-dialog-title>
  <mat-icon style="color: var(--blue_color); margin-right: 8px">system_update</mat-icon>
  Actualización disponible
</h2>
<mat-dialog-content cdkScrollable>
  <p>
    Hay una nueva versión disponible: <strong>{{ data.version }}</strong>
  </p>
  @if (is_installing()) {
    <p>Descargando e instalando la actualización. La aplicación se cerrará automáticamente…</p>
  } @else {
    <p>¿Deseas reiniciar la aplicación ahora para instalar la actualización?</p>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [disabled]="is_installing()" (click)="close()">Más tarde</button>
  <button mat-button [disabled]="is_installing()" (click)="restartAndInstall()" style="color: var(--blue_color)">
    {{ is_installing() ? 'Instalando…' : 'Reiniciar e instalar' }}
  </button>
</mat-dialog-actions>
